import React, { Component } from 'react'
import ContentAdd from 'material-ui/svg-icons/content/add'
import Layout from '../../components/Layout'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { readingTimeActions } from '../../actions'
import Typography from '@material-ui/core/Typography'
import CrudHeader from '../../components/CrudHeader'
import { crudListStyle } from '../../styles'
import { Button } from '@material-ui/core'
import UserToolbar from '../../components/UserToolbar'

class ReadingTime extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newReadingTime, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Tempo de leitura'}
          classes={classes}
          newResource={newReadingTime}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'tempos_leitura'}
        />

        {modalOpen && <EditModal open={modalOpen} onClose={closeModal} />}

        <ListTable />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.readingTimes.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(readingTimeActions.openModal())
    },
    closeModal: () => {
      dispatch(readingTimeActions.closeModal())
    },
    newReadingTime: readingTime => {
      dispatch(readingTimeActions.newForm(readingTime))
    },
    resetState: () => {
      dispatch(readingTimeActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(ReadingTime))



// WEBPACK FOOTER //
// ./src/containers/ReadingTime/index.js